module.exports = __webpack_public_path__ + "img/lpdm-couverture-accueil.e23f384c.png";